import React from 'react';
import { useSelector } from 'react-redux';
import { PowerIcon } from 'evergreen-ui';
import { datasourceStatusEnabledModeSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { timeZoneSelector } from 'Features/App/appSlice';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import StatusIcon from './StatusIcon';
import { DatasourceIdProps } from '../utils';
import { StatusDataType } from './utils';

export function EnableModeStatus({ datasourceId }:DatasourceIdProps) {
  const selectedZone = useSelector(timeZoneSelector);
  const status = useSelector(datasourceStatusEnabledModeSelector(datasourceId));

  const { text, intent, time }: StatusDataType = React.useMemo(() => {
    const { enabled, dateTimeUpdate } = status || {};

    if (enabled === true) {
      return {
        time: dateTimeUpdate !== null ? UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone) : '',
        text: 'Источник данных включен',
        intent: 'success',
      };
    }
    if (enabled === false) {
      return {
        time: dateTimeUpdate !== null ? UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone) : '',
        text: 'Источник данных выключен',
        intent: 'danger',
      };
    }

    return {
      text: 'Cостояние источника: Неизвестно',
      intent: 'none',
      time: '',
    };
  }, [selectedZone.selectedUserTimeZone, status]);

  return (
    <StatusIcon
      time={time}
      statusInfo={text}
      intent={intent}
      icon={PowerIcon}
    />
  );
}
export default EnableModeStatus;
